module.exports = __webpack_public_path__ + "media/bootstrap-icons/question-square-fill-0f5bebb2.svg";